import { Box, Container, Typography } from "@mui/material";
import { FormAnuncio } from "../../componente/Anuncio/FormAnuncio"
import { GetVoidAnunciosData } from "../../types/Anuncio/AnuncioData";
import { themePalette } from "../../config/theme.config";


export const AddAnuncioPage: React.FC<{}> = () => {

    return (<Container maxWidth="lg" style={{ border: `1px solid ${themePalette.NAVCOLOR}`, borderRadius: '5px', padding: '20px', borderTopWidth: '3px', textAlign: 'center', marginTop: 10 }}>
        
            <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: `${themePalette.NAVCOLOR}` }}>
                Crear Comunicado
            </Typography>
            <Box sx={{ display: 'flex', m: 2 }}>
                <FormAnuncio anuncio={GetVoidAnunciosData()} />
            </Box>
        </Container>
    );
};